var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3242 44.8158L20.0009 42.1392",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 6.02251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94141 41.8048L11.6368 34.1094",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 6.02251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1103 5L3.94141 18.0488L17.9939 26.0788C20.8937 27.4171 28.0315 29.7592 30.7081 23.4021C28.0315 25.4096 24.8195 31.0976 28.0315 36.4509L35.7269 49.4997L49.1103 5Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 6.02251,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentSend);
export default __webpack_public_path__ + "static/media/comment_send.28895278f47ed87ae9eb255f497ec5c3.svg";
export { ForwardRef as ReactComponent };